import { render, staticRenderFns } from "./AlermList.vue?vue&type=template&id=b69a367e&scoped=true&"
import script from "./AlermList.vue?vue&type=script&lang=js&"
export * from "./AlermList.vue?vue&type=script&lang=js&"
import style0 from "./AlermList.vue?vue&type=style&index=0&id=b69a367e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69a367e",
  null
  
)

export default component.exports